import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import store from './store';
import moment from 'moment'

Vue.config.productionTip = false

new Vue({
  store,
  router,
  vuetify,
  moment,
  render: h => h(App)
}).$mount('#app')
